import axios from 'axios';

export const CONTENTFUL_MOCK_URL = '/api/contentful/';

const getContentfulMock = async (entry: string) => {
    return await axios.get(`${CONTENTFUL_MOCK_URL}${entry}`).then((response) => response.data);
};

export const createMockClient = () => ({
    getEntry: async (entryId: string) => getContentfulMock(`${entryId}-entry`),
    getEntries: async (options: Record<string, any>) => getContentfulMock(`${options.content_type}-entries`),
    withoutUnresolvableLinks: {
        getEntry: async (entryId: string) => getContentfulMock(`${entryId}-entry`),
        getEntries: async (options: Record<string, any>) => getContentfulMock(`${options.content_type}-entries`),
    },
});
